import { Input } from "@progress/kendo-react-inputs";

export const ImageWidthProperty = {
  propertyName: "ImageWidth",
  propertyDisplay: "Image Width (px)",
  propertyType: "number",
  propertyCategory: "Style",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Input
        name={this.propertyName}
        type="number"
        min={0}
        placeholder="Auto"
        onBlur={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || ""}
      />
    );
  },
};
export const ImageHeightProperty = {
  propertyName: "ImageHeight",
  propertyDisplay: "Image Height (px)",
  propertyType: "number",
  propertyCategory: "Style",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Input
        name={this.propertyName}
        type="number"
        min={0}
        placeholder="Auto"
        onBlur={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || ""}
      />
    );
  },
};
